import styled from 'styled-components';
import { FlexColumn } from '@equifinance/shared';
import { StaticDataItem } from '../../../../../api/useAccountApi';
import PositionSection from './PositionSection';
import IncomeSection from './IncomeSection';
import { withExpandableRowErrors } from '../../../../Errors/ExpandableRowErrors';
import { EmploymentHistory, EmploymentWithIncome } from '../../../../../contexts/account/IncomeAndEmployment';
import EmployerDetailsSection from './EmployerDetailsSection';

const Container = styled(FlexColumn)`${({ theme }) => `
  gap:${theme.padding[4]};
  padding: ${theme.padding[4]};
`}`;

export function EmploymentHistoryExpandable({
  data: employmentHistory,
  applicantIndex,
  ukCountries,
  industries,
  jobTitles,
  employmentHistoryIndices,
}: {
  data: EmploymentHistory,
  applicantIndex: number,
  ukCountries: StaticDataItem[],
  industries: StaticDataItem[],
  jobTitles: StaticDataItem[],
  employmentHistoryIndices: Record<string, number>,
}) {
  const employmentHistoryIndex = employmentHistoryIndices[employmentHistory.id];
  const { currentlyWorkingInThisRole, employmentType } = employmentHistory as EmploymentWithIncome;

  return (
    <Container>
      <PositionSection
        employmentHistory={employmentHistory}
        applicantIndex={applicantIndex}
        countries={ukCountries}
        industries={industries}
        jobTitles={jobTitles}
        employmentHistoryIndex={employmentHistoryIndex}
      />

      {currentlyWorkingInThisRole
        && employmentType
        && (
          <>
            <EmployerDetailsSection
              employmentHistory={employmentHistory}
              applicantIndex={applicantIndex}
              ukCountries={ukCountries}
              employmentHistoryIndex={employmentHistoryIndex}
            />
            <IncomeSection
              employmentHistory={employmentHistory}
              applicantIndex={applicantIndex}
              employmentHistoryIndex={employmentHistoryIndex}
            />
          </>
        )}
    </Container>
  );
}

export default withExpandableRowErrors(EmploymentHistoryExpandable);
